import angular from 'angular';

export default angular.module('directives.consent', [])
.component('consent', {
	template: require('./consent.html'),
	controller: function($scope, $cookies) 
	{
		'ngInject';
		var _consent = $cookies.get('cookie-consent');
		$scope.consent = function(consent) 
		{
			if (consent === undefined) 
			{
				return _consent;
			} 
			else if (consent) 
			{
				var v = new Date();
				v.setDate(v.getDate() + 999);
				$cookies.put('cookie-consent', true, { expires: v }); // Expira en 3 años
				_consent = true;
			}
		};

		$scope.moreinfo = function()
		{
			var modalInstance = $uibModal.open({
				// animation: $scope.animationsEnabled,
				templateUrl: 'components/footer/privacy_policy.html',
				controller: function($scope, $uibModalInstance)
				{
					$scope.ok = function()
					{
						$uibModalInstance.dismiss();
					};
				}
			});
		};
	}
})
.name;



// WEBPACK FOOTER //
// ./client/components/cookie-consent/consent.component.js